import React, { useContext } from "react";
import { Row, Col, Container } from "react-bootstrap";
import PsContext from "../../../context";

const StepsToFollow = () => {
  const context = useContext(PsContext);
  const academicYear = context.settingValue("current_academic_year");
  const allowMobileVerify =
    context.settingValue("allow_user_mobile_verification") == 1;

  const steps = allowMobileVerify
    ? [
        { title: "Register Yourself", icon: "fa-user-check", variant: 1 },
        { title: "Verify Via Mobile", icon: "fa-shield-halved", variant: 2 },
        {
          title: "Fill application from Online",
          icon: "fa-file-lines",
          variant: 3,
        },
        {
          title: "Upload required Documents",
          icon: "fa-cloud-arrow-up",
          variant: 4,
        },
        { title: "Fee Payment", icon: "fa-credit-card", variant: 5 },
        {
          title: "Download application",
          icon: "fa-file-arrow-down",
          variant: 6,
        },
      ]
    : [
        { title: "Register Yourself", icon: "fa-user-check", variant: 1 },
        {
          title: "Fill application from Online",
          icon: "fa-file-lines",
          variant: 2,
        },
        {
          title: "Upload required Documents",
          icon: "fa-cloud-arrow-up",
          variant: 3,
        },
        { title: "Fee Payment", icon: "fa-credit-card", variant: 4 },
        {
          title: "Download application",
          icon: "fa-file-arrow-down",
          variant: 5,
        },
      ];

  return (
    <section className="bg-white border-top border-bottom py-5">
      <Container>
        <Row className="text-center mb-5">
          <Col md={12}>
            <div className="section-title-dark mb-2">Steps to Follow</div>
            <p className="text-muted fs-13 fw-600 opacity-75 letter-spacing-1">
              Easy path to join our institution for {academicYear}
            </p>
          </Col>
        </Row>
        <Row className="g-4">
          {steps.map((item, index) => (
            <Col lg={2} md={4} sm={6} xs={12} key={index}>
              <div
                className={`program-card step-variant-${item.variant} h-100 flex-column text-center px-2 py-4`}
                style={{
                  position: "relative",
                  gap: "12px",
                  borderWidth: "2px",
                }}
              >
                <div
                  className="step-pill-modern"
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: "2",
                    whiteSpace: "nowrap",
                    padding: "3px 15px",
                    fontSize: "10px",
                  }}
                >
                  STEP {index + 1}
                </div>

                <div
                  className="program-icon-box mx-auto"
                  style={{ fontSize: "22px", width: "45px", height: "45px" }}
                >
                  <i className={`fa-solid ${item.icon}`}></i>
                </div>

                <div className="program-info p-0">
                  <div
                    className="title text-uppercase fw-800"
                    style={{
                      fontSize: "10.5px",
                      lineHeight: "1.3",
                      color: "#333",
                    }}
                  >
                    {item.title}
                  </div>
                  <div
                    className="subtitle fw-600 mt-1"
                    style={{ fontSize: "9px", opacity: "0.7" }}
                  >
                    Admission Process
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StepsToFollow;
